import React from 'react';
import { Link } from 'react-router-dom';

const Player = () => {
  
  return (
  <>
  <div className="container">
  <Link to="/" className="link">Home</Link>
  </div>
  </>
)
}

export default Player;
